/**
 * Der grüne Haken.
 *
 * Steht an allem, was ein Mensch angesehen und bestätigt hat — Belege wie
 * Kontoauszugspositionen, in jeder Liste dieselbe Form. Ein Beirat, der
 * zwei Stunden durch 186 Zeilen geht, muss auf einen Blick sehen, wo er
 * stehengeblieben ist; dafür taugt nur ein Zeichen, das überall gleich
 * aussieht und gleich bedeutet.
 *
 * Als SVG und nicht als Schriftzeichen: ✓ fehlt in manchen Schriftarten und
 * wird dann als Kästchen gezeichnet. Dazu ein `title`, damit nicht nur die
 * Farbe die Aussage trägt.
 */

export type HakenZustand = 'offen' | 'geprueft' | 'rueckfrage';

export function Haken({
  zustand,
  gross = false,
}: {
  zustand: HakenZustand;
  /** Für Listen mit größerer Zeilenhöhe, etwa die Sachkontentabelle. */
  gross?: boolean;
}) {
  if (zustand === 'offen') return null;

  const groesse = gross ? 18 : 15;
  const geprueft = zustand === 'geprueft';

  return (
    <span
      className={`haken${geprueft ? ' ok' : ' frage'}`}
      title={geprueft ? 'Geprüft und bestätigt' : 'Rückfrage offen'}
      aria-label={geprueft ? 'Geprüft und bestätigt' : 'Rückfrage offen'}
      role="img"
      style={{ width: groesse, height: groesse }}
    >
      {geprueft ? (
        <svg viewBox="0 0 16 16" width={groesse - 4} height={groesse - 4} aria-hidden>
          <path
            d="M3.5 8.5l3 3 6-6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg viewBox="0 0 16 16" width={groesse - 4} height={groesse - 4} aria-hidden>
          <path
            d="M8 4v5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <circle cx="8" cy="12" r="1.2" fill="currentColor" />
        </svg>
      )}
    </span>
  );
}
